import Vue from 'vue';

export default new Vue()

export function emitWinBus(eventName) {
  if (window && window.VueBus) {
    window.VueBus.$emit(eventName, ...arguments)
  }
}
